import React from 'react'

import { ReactComponent as ClubSVG } from '../../assets/svg/suits/club.svg'
import { ReactComponent as SpadeSVG } from '../../assets/svg/suits/spades.svg'
import { ReactComponent as DiamondSVG } from '../../assets/svg/suits/diamond.svg'
import { ReactComponent as HeartSVG } from '../../assets/svg/suits/heart.svg'

export default function useCard() {
  const handleCardColor = (c: any, r?: string, b?: string): any => {
    const cardSuitColor = c.charAt(0)
    switch (cardSuitColor) {
      case 'S':
      case 'C':
        return b
      case 'D':
      case 'H':
        return r
      default:
        return b
    }
  }
  const handleCardSuit = (c: string): any => {
    const cardSuit = c.charAt(0)
    switch (cardSuit) {
      case 'S':
        return <SpadeSVG viewBox='0 0 31 25' className='suit' />
      case 'C':
        return <ClubSVG viewBox='0 0 28 26' className='suit' />
      case 'H':
        return <HeartSVG viewBox='0 0 31 25' className='suit' />
      case 'D':
        return <DiamondSVG viewBox='0 0 31 31' className='suit' />
      default:
        return c
    }
  }
  const handleCardSymbol = (c: string): string => {
    const cardSymbol = c.substring(1, c.length)
    switch (cardSymbol) {
      case '11':
        return 'J'
      case '12':
        return 'Q'
      case '13':
        return 'K'
      case '1':
        return 'A'
      case '0':
        return ''
      default:
        return cardSymbol
    }
  }
  return { handleCardSymbol, handleCardSuit, handleCardColor }
}
